import { ReportType } from "../ReportTableManage/index.type";

export interface DiscoverySearchProps{
    searchQuery: string;
    handleSelect: (report: any) => void;
    selectedFilter: string;
     allData: Category[];
}

export type Category = {
  id: string
  categoryEn: string
  categoryFr: string
  descriptionEn: string | null
  descriptionFr: string | null
  reports: ReportType[]
}

export interface DiscoveryAccordionProps{
 list: Category[];
 expandedCategoryId?: string | null;
}

export interface DiscoveryProps{
    searchQuery: string;
    handleSelect: (report: any) => void;
    selectedFilter: string;
    list: any;
}

export enum DiscoverySearchType {
    Report = "1",
    Category = "2",
}